import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';
import { shadows } from '../shadows';

export const MuiAlert: Components<Theme>['MuiAlert'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${colors.gray[100]}`,
      boxShadow: shadows[4],
      padding: theme.spacing(1, 2),
      borderRadius: theme.spacing(1.5),
      ...theme.applyStyles('dark', {
        border: `1px solid ${colors.black[800]}`,
      }),
    }),
  },
};
